import React, { useContext, useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { CartContext } from './contexts/CartContext';
import { FavoriteContext } from './contexts/FavoriteContext';
import { db } from './../firebase/firebaseConfig'; // Adjust the import if needed
import { doc, getDoc, collection, query, where, limit, getDocs } from "firebase/firestore";

import { Button, Snackbar, Alert } from '@mui/material';
import "./css/ProductDetails.css"


import Footer from './includes/Footer';
import PageTitle from './includes/PageTitle';


function ProductDetails() {
  const { id } = useParams(); // Assuming you're passing the product ID via URL

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const navigate = useNavigate();
  const { addToCart } = useContext(CartContext);
  const { favorites, addFavorite, removeFavorite } = useContext(FavoriteContext);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const productDoc = await getDoc(doc(db, "Products", id));
        if (productDoc.exists()) {
          const productData = productDoc.data();
          setProduct({ id: productDoc.id, ...productData });
          setSelectedColor(productData.colors && productData.colors.length > 0 ? productData.colors[0] : null);
          setSelectedSize(productData.sizes && productData.sizes.length > 0 ? productData.sizes[0] : null);
        
          // Fetch related products
          fetchRelatedProducts(productData.category, productData.subCategory);
        } else {
          console.log("No such product!");
          setProduct(null); // Explicitly set product to null if not found
        }
      } catch (error) {
        console.error("Error fetching product: ", error);
      } finally {
        setLoading(false);
      }
    };


    const fetchRelatedProducts = async (category, subCategory) => {
      try {
        let relatedQuery = query(
          collection(db, "Products"),
          where("category", "==", category),
          where("subCategory", "==", subCategory),
          limit(4)
        );

        let relatedDocs = await getDocs(relatedQuery);
        let relatedProductsData = relatedDocs.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

        if (relatedProductsData.length < 4) {
          // If fewer than 4 products found, fetch more random products
          const randomQuery = query(collection(db, "Products"), limit(4 - relatedProductsData.length));
          const randomDocs = await getDocs(randomQuery);
          const randomProducts = randomDocs.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          relatedProductsData = [...relatedProductsData, ...randomProducts];
        }

        setRelatedProducts(relatedProductsData);
      } catch (error) {
        console.error("Error fetching related products: ", error);
      }
    };

 
    fetchProduct();
  }, [id]);

  const handleAddToCart = () => {
    if (product && selectedColor && selectedSize) {
      const item = {
        id: product.id,
        name: product.name,
        price: product.price,
        images: product.images,
        quantity: 1,
        color: selectedColor,
        size: selectedSize,
      };
      addToCart(item);
    } else {
      console.error("Product, color, or size is not available.");
    }
  };

  const handleToggleFavorite = (product) => {
    if (favorites.some(item => item.id === product.id)) {
      removeFavorite(product.id);
    } else {
      addFavorite(product);
    }
  };

  if (loading) {
    return (
      <div style={{ height: "100vh" }} className='d-flex justify-content-center align-items-center'>
        <div className="spinner-border" style={{ width: "5em", height: "5em" }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  
  if (!product) {
    navigate('/404')
  }


  // Whatsapp buy now functionality
  // Example on the product card component
const handleWhatsAppRedirect = (product) => {
  // Construct the message to send via WhatsApp
  const message = `Hello, I am interested in the product: 
  Name: ${product.name}. 
  Price: ₦${product.price}. 
  Selected Color: ${selectedColor}.
  Selected Size: ${selectedSize}.
  Product ID: #${product.id}.
  Could you provide more details?`;
   


  // URL encode the message to ensure special characters are handled correctly
  const encodedMessage = encodeURIComponent(message);

  // WhatsApp link with the pre-filled message (replace with your WhatsApp number)
  const whatsappUrl = `https://wa.me/+2348157081943?text=${encodedMessage}`;

  // Redirect to WhatsApp chat
  window.open(whatsappUrl, '_blank');
};


  

  return (
    <>
    <PageTitle title={`${product.name} - ALMOSTINVISIBLE`} />

      
    <div className="product-page" style={{ paddingBottom: "15vh" }}>
      <div className="px-4">
        <div className="row g-5 mb-1">

          
          <div className="col-lg-8 product-images">
            <div className="row g-0">
              {product.images.map((url, index) => (
                <img key={index} src={url} alt={`Product ${index}`} />
              ))}
              
            </div>
          </div>


          <div className="col-lg-4 product-desc sticky-lg-top">
            <h4 className="unbounded fw-light">{product.name}</h4>
            <h4 className="unbounded" style={{ textDecoration: "underline" }}>
               ₦{product.price}
            </h4>
            <hr />
            <h6 className="unbounded" style={{ textDecoration: "underline" }}>
              Details
            </h6>
            <p style={{ fontSize: "small" }}>
              {product.productDetails}
            </p>
            
            <p className="text-muted">#{product.id}</p>
            <hr />
            <div>
                  <h6 className="unbounded" style={{ textDecoration: "underline" }}>
                    Colors
                  </h6>
                    <div className="p-colors radio-inputs d-flex">
                      {product.colors.map((color, index) => (
                        <label key={index}>
                          <input
                            className="radio-input color-radio-input"
                            type="radio"
                            name="color"
                            value={color}
                            onChange={() => setSelectedColor(color)}
                            checked={selectedColor === color}
                          />
                          <span className="radio-tile color-tile" style={{ backgroundColor: color }}></span>
                        </label>
                      ))}
                  </div>
            </div>

              

            <br />


            <div className="p-sizes">
                <h6 className="unbounded" style={{ textDecoration: "underline" }}>
                  Sizes
                </h6>
                <div className="radio-inputs">
                  {product.sizes.map((size, index) => (
                      <label key={index}>
                        <input
                          className="radio-input"
                          type="radio"
                          name="size"
                          value={size}
                          onChange={() => setSelectedSize(size)}
                          checked={selectedSize === size}
                        />
                        <span className="radio-tile">
                          <span className="radio-label">{size}</span>
                        </span>
                      </label>
                    ))}
                </div>
              </div>


            {/** SIZE HELP MODAL BUTTON */}
            <button
              type="button"
              style={{ textDecoration: "underline", fontSize: "small" }}
              className="unbounded mt-2"
              data-bs-toggle="modal"
              data-bs-target="#sizeHelp"
            >
              Size Help
            </button>


            <br />
            <br />
            
            <div className="d-flex flex-column">
              <button
                className="whatsapp-button black-bordered-button "
                onClick={() => handleWhatsAppRedirect(product)}
              >
                <svg stroke="white" fill="#25d366" stroke-width="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M260.062 32C138.605 32 40.134 129.701 40.134 250.232c0 41.23 11.532 79.79 31.559 112.687L32 480l121.764-38.682c31.508 17.285 67.745 27.146 106.298 27.146C381.535 468.464 480 370.749 480 250.232 480 129.701 381.535 32 260.062 32zm109.362 301.11c-5.174 12.827-28.574 24.533-38.899 25.072-10.314.547-10.608 7.994-66.84-16.434-56.225-24.434-90.052-83.844-92.719-87.67-2.669-3.812-21.78-31.047-20.749-58.455 1.038-27.413 16.047-40.346 21.404-45.725 5.351-5.387 11.486-6.352 15.232-6.413 4.428-.072 7.296-.132 10.573-.011 3.274.124 8.192-.685 12.45 10.639 4.256 11.323 14.443 39.153 15.746 41.989 1.302 2.839 2.108 6.126.102 9.771-2.012 3.653-3.042 5.935-5.961 9.083-2.935 3.148-6.174 7.042-8.792 9.449-2.92 2.665-5.97 5.572-2.9 11.269 3.068 5.693 13.653 24.356 29.779 39.736 20.725 19.771 38.598 26.329 44.098 29.317 5.515 3.004 8.806 2.67 12.226-.929 3.404-3.599 14.639-15.746 18.596-21.169 3.955-5.438 7.661-4.373 12.742-2.329 5.078 2.052 32.157 16.556 37.673 19.551 5.51 2.989 9.193 4.529 10.51 6.9 1.317 2.38.901 13.531-4.271 26.359z"></path></svg>               
                &nbsp;Buy Now Via Whatsapp
              </button>
              <br />
              <div className="d-flex">
                <button id="addToCartBtn" onClick={handleAddToCart} className="black-button unbounded">
                        <span className='unbounded'>ADD TO BAG &nbsp;</span>
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth={0}
                          viewBox="0 0 16 16"
                          height="1.2em"
                          width="1.2em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M14 5H2v9a1 1 0 001 1h10a1 1 0 001-1V5zM1 4v10a2 2 0 002 2h10a2 2 0 002-2V4H1z"
                            clipRule="evenodd"
                          />
                          <path d="M8 1.5A2.5 2.5 0 005.5 4h-1a3.5 3.5 0 117 0h-1A2.5 2.5 0 008 1.5z" />
                        </svg>
                </button>
                &nbsp; &nbsp;
                <button className="d-flex justify-content-center align-items-center p-2" style={{ color: 'black', cursor: 'pointer', backgroundColor: '#d9d9da', borderRadius: '50%' }} onClick={() => handleToggleFavorite(product)}>
                    {favorites.some(item => item.id === product.id) ? (
                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"></path></svg>
                        
                        
                    ) : (
                      <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg">
                            <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"></path>
                        </svg>
                    )}
                </button>
              </div>
            </div>


            <br />
            
            
            <div className="d-flex flex-column justify-content-start">
              <button
                type="button"
                style={{
                  textDecoration: "underline",
                  fontSize: "small",
                  textAlign: "start"
                }}
                className="unbounded mt-2"
                data-bs-toggle="modal"
                data-bs-target="#shippingAndReturns"
              >
                SHIPPING &amp; RETURNS
              </button>
              <button
                type="button"
                style={{
                  textDecoration: "underline",
                  fontSize: "small",
                  textAlign: "start"
                }}
                className="unbounded mt-2"
                data-bs-toggle="modal"
                data-bs-target="#paymentMethods"
              >
                PAYMENT METHODS
              </button>
              <button
                type="button"
                style={{
                  textDecoration: "underline",
                  fontSize: "small",
                  textAlign: "start"
                }}
                className="unbounded mt-2"
                data-bs-toggle="modal"
                data-bs-target="#helpAndContact"
              >
                HELP AND CONTACT
              </button>
            </div>
          </div>
        </div>
        </div>
       

        {/* Nav tabs */}
        <div className=" px-4">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <a
                  className="nav-link active unbounded"
                  data-bs-toggle="tab"
                  href="#materials"
                >
                  Materials
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link unbounded"
                  data-bs-toggle="tab"
                  href="#fittings"
                >
                  Fittings
                </a>
              </li>
            </ul>
            {/* Tab panes */}
            <div className="tab-content mt-3">
              <div id="materials" className="tab-pane active">
                <ul style={{ listStyle: "circle" }}>
                

                  {product.materials.map((material, index) => (
                    <li>{material}</li>
                  ))}
                </ul>
              </div>
              <div id="fittings" className="tab-pane fade">
                <ul style={{ listStyle: "circle" }}>
                  <li>Model Name: {product.modelName}</li>
                  <li>Height: {product.modelHeight}</li>
                  <li>Chest: {product.chest}</li>
                  <li>Waist: {product.waist}</li>
                </ul>
              </div>
            </div>
        </div>
        
        {/* Related Products Section COME BACK TO THIS 
      <div className="related-product mt-4">
        <h5 className="unbounded">You Might Also Like</h5>
        <div className="rel-cards">
          <div className="row g-0">
            {relatedProducts.map((relProduct) => (
              <div key={relProduct.id} className="col-md-6 col-xl-4 col-sm-6 col-12 p-card-wrap p-0">
                <div className="px-3">
                  <Link to={`/p/${product.id}`} className='prod-link'>
                    <div className="p-card">
                      <div className="product-image-container">
                        <div className="card-image">
                          <img src={relProduct.images[0]} alt={relProduct.name} />
                        </div>
                      </div>
                      <div className="p-card-details mt-3 px-3">
                        <h6 className="fw-bold nunito-2">{relProduct.name}</h6>
                        <p className='nunito-2'>₦{relProduct.price}</p>
                      </div>
                    </div>
                  </Link>
                


                  <div className="d-flex justify-content-between p-3">
                      <button className="black-button d-flex align-content-center" onClick={() => handleAddToCart(product)}>
                        <span className='unbounded' style={{ fontSize: "15px" }}>Add to bag &nbsp;</span>
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" d="M14 5H2v9a1 1 0 001 1h10a1 1 0 001-1V5zM1 4v10a2 2 0 002 2h10a2 2 0 002-2V4H1z" clipRule="evenodd" />
                          <path d="M8 1.5A2.5 2.5 0 005.5 4h-1a3.5 3.5 0 117 0h-1A2.5 2.5 0 008 1.5z" />
                        </svg>
                      </button>
                      <button className="d-flex justify-content-center align-items-center p-2 border-0" style={{ color: 'black', cursor: 'pointer', backgroundColor: 'white', borderRadius: '50%' }} onClick={() => handleToggleFavorite(product)}>
                          {favorites.some(item => item.id === product.id) ? (
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"></path></svg>
                              
                              
                              
                          ) : (
                            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"></path>
                              </svg>
                          )}
                      </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
*/}


      </div>
  


    {/* The Modal */}
    <div className="modal fade" id="sizeHelp">
      <div className="modal-dialog modal-lg">
        <div className="modal-content container">
          {/* Modal body */}
          <div className="modal-body">
            <div className="d-flex justify-content-between">
              <h4 className="unbounded" style={{ textDecoration: "underline" }}>
                SIZE HELP
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>
            <div>
              <p>Model Alexandre Sewa wears size M</p>
              <p>Height: 5' 11" (182 cm)</p>
              <p>Chest: 32" (81 cm)</p>
              <p>Waist: 26" (68 cm)</p>
            </div>
            <table className="table">
              <thead>
                <tr>
                  <th>Standard</th>
                  <th>EUROPE (EU)</th>
                  <th>UNITED STATES (US)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>XXS</td>
                  <td>42</td>
                  <td>32</td>
                </tr>
                <tr>
                  <td>XS</td>
                  <td>44</td>
                  <td>34</td>
                </tr>
                <tr>
                  <td>S</td>
                  <td>46</td>
                  <td>36</td>
                </tr>
                <tr>
                  <td>M</td>
                  <td>48</td>
                  <td>38</td>
                </tr>
                <tr>
                  <td>L</td>
                  <td>50</td>
                  <td>40</td>
                </tr>
                <tr>
                  <td>XL</td>
                  <td>52</td>
                  <td>42</td>
                </tr>
                <tr>
                  <td>XXL</td>
                  <td>54</td>
                  <td>44</td>
                </tr>
                <tr>
                  <td>3XL</td>
                  <td>56</td>
                  <td>46</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    {/* The Modal */}
    <div className="modal fade" id="shippingAndReturns">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content container">
          {/* Modal body */}
          <div className="modal-body">
            <div className="d-flex justify-content-between">
              <h4 className="unbounded" style={{ textDecoration: "underline" }}>
                Shipping And RETURNS
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>
            <p>
              Delivery within Lagos is within 1-3 days, other states in Nigeria
              are 2-5 days. Delivery duties are included in the item price when
              shipping to all EU countries, New Europe, Switzerland, Japan, South
              Korea, Hong Kong SAR, Canada, China Mainland, Singapore, Australia,
              Taiwan Region, Thailand, United Arab Emirates and the United States.
              All import duties are included in your order the price you see is
              the price you pay.
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* The Modal */}
    <div className="modal fade" id="paymentMethods">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content container">
          {"{"}/* Modal body */{"}"}
          <div className="modal-body">
            <div className="d-flex justify-content-between">
              <h4 className="unbounded" style={{ textDecoration: "underline" }}>
                Payment Methods
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>
            <p>
              We accept all major credits cards and debit cards like Mastercard,
              Verve, Visa. Also you can make transfers if you are in Nigeria or if
              you can transfer to Nigerian banks.
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* The Modal */}
    <div className="modal fade" id="helpAndContact">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content container">
          {/* Modal body */}
          <div className="modal-body">
            <div className="d-flex justify-content-between">
              <h4 className="unbounded" style={{ textDecoration: "underline" }}>
                HELP AND CONTACT
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>
            <div className="d-flex flex-column">
              <a href="tel:+2349071838043" style={{ color: "black" }}>
                Phone NGN: +234 9071838043
              </a>
              <a
                href="mailto:vlmstnvsbl@gmail.com"
                style={{ color: "black" }}
              >
                Email: vlmstnvsbl@gmail.com
              </a>
            </div>
            <br />
            <p>
              Customer service support, inquiries related to: prices and currency,
              order and preorder payment, order status, shipment info, return, and
              exchange.
              <br />
              Need more information? Send us a message
            </p>
            <div className="social">
              
              <a href="https://www.instagram.com/almostinvisibleispeak/profilecard/?igsh=MWtkbG9ocWdmMmJ3cg==" target='_blank'>
                <svg
                  stroke="currentColor"
                  fill="black"
                  strokeWidth={0}
                  viewBox="0 0 1024 1024"
                  height="1.6em"
                  width="1.6em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 0 0-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z" />
                </svg>
              </a>

              <a href="https://x.com/vlmstnvsbl?s=21&t=X0vqH7bGqWrInzVTaFWvbA" target='_blank'>
                <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" height="1.5em" width="1.5em" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 462.799"><path fill-rule="nonzero" d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z"/></svg>
              </a>
             
              <a href="https://wa.me/+2348157081943" target='_blank'>
              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path></svg>              </a>
              {/*
              <a href="https://pin.it/7ybKOb890" target='_blank'>
              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12,0 C5.37225,0 0,5.37225 0,12 C0,17.0835 3.16275,21.426 7.62675,23.17425 C7.52175,22.22475 7.42725,20.76825 7.66875,19.73175 C7.88625,18.79575 9.07575,13.767 9.07575,13.767 C9.07575,13.767 8.7165,13.0485 8.7165,11.98575 C8.7165,10.317 9.684,9.07125 10.88775,9.07125 C11.9115,9.07125 12.4065,9.84 12.4065,10.76175 C12.4065,11.7915 11.751,13.3305 11.41275,14.757 C11.13,15.95175 12.01125,16.926 13.1895,16.926 C15.3225,16.926 16.962,14.67675 16.962,11.43075 C16.962,8.5575 14.89725,6.54825 11.949,6.54825 C8.535,6.54825 6.531,9.1095 6.531,11.75625 C6.531,12.7875 6.92775,13.89375 7.4235,14.4945 C7.52175,14.61375 7.536,14.71725 7.50675,14.83875 C7.416,15.21825 7.2135,16.03275 7.17375,16.2 C7.12125,16.419 6.99975,16.46625 6.7725,16.3605 C5.27325,15.66225 4.3365,13.4715 4.3365,11.71125 C4.3365,7.926 7.08675,4.44975 12.2655,4.44975 C16.428,4.44975 19.6635,7.416 19.6635,11.3805 C19.6635,15.516 17.05575,18.8445 13.43625,18.8445 C12.2205,18.8445 11.0775,18.21225 10.686,17.466 C10.686,17.466 10.0845,19.75725 9.93825,20.319 C9.6675,21.36075 8.93625,22.66725 8.4465,23.4645 C9.57,23.8125 10.76325,24 12,24 C18.62775,24 24,18.627 24,12 C24,5.37225 18.62775,0 12,0"></path></svg>
              </a>
              
              <a href="#">
                <svg
                  stroke="currentColor"
                  fill="black"
                  strokeWidth={0}
                  role="img"
                  viewBox="0 0 24 24"
                  height="1.5em"
                  width="1.5em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title />
                  <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
                </svg>
              </a>*/}
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
    </>
  );
}

export default ProductDetails;

